const TreatementSection = () => {
  const treatments = [
    {
      title: "EAR EXAMINATION & IRRIGATION",
      points: ["Visual ear check using otoscope", "Gentle ear irrigation", "Can be done at your hotel or villa"],
    },
    {
      title: "WOUND TREATMENT & STITCHES",
      points: ["On-site wound treatment", "Safe and sterile stitching at your hotel or villa"],
    },
    {
      title: "LABORATORY TESTS",
      points: ["Blood, urine, and stool sample collection at your hotel or villa", "Results delivered and explained via WhatsApp"],
    },
    {
      title: "NEBULIZER",
      points: ["Treatment using nebulizer for patient with asthma attack", "Can be done at your hotel or villa"],
    },
  ];

  return (
    <div className='p-4 lg:p-12 lg:mb-24 '>
      <h1 className='text-4xl lg:px-12 lg:py-3 lg:text-4xl font-bold text-[#4FBAA8] mb-6 lg:w-[950px] leading-tight'>We also do :</h1>
      <div className='flex flex-wrap justify-center gap-5 md:flex-row'>
        {treatments.map((treatment, index) => (
          <div key={index} className='w-full max-w-xs rounded-xl bg-gray-100 p-4 shadow-lg lg:w-1/4'>
            <div className='mb-5 rounded-lg bg-teal-600 lg:p-3 p-3 text-center font-bold text-white'>{treatment.title}</div>
            <ul className='list-none space-y-2 p-0'>
              {treatment.points.map((point, pointIndex) => (
                <li key={pointIndex} className='relative pl-5 text-gray-700'>
                  <span className='absolute left-0 top-0 text-teal-600'>•</span>
                  {point}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TreatementSection;
